import {type AxiosResponse} from 'axios';

export const getResponseResults = <T>(
	response: AxiosResponse<{result: T}, any>,
) => response.data.result;
